import React, { useCallback, useState } from "react";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import { exportPersonsToCSV } from "common/services/persons.service";
import ExportLoadingModal from "Components/Common/ExportLoadingModal";
import Permission from "Components/Common/Permission";
import { toast } from "react-toastify";
import PersonsImportModal from "./PersonsImportModal";

const Import = ({
  apiParams,
  onImported,
}: {
  apiParams: any;
  onImported?: () => void;
}) => {
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);

  const [exporting, setExporting] = useState(false);
  const getCsvExport = useCallback(async () => {
    setExporting(true);

    await exportPersonsToCSV({
      filters: apiParams.filters,
      sort: apiParams.sort,
    })
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Person_Export.csv"); // Set the download attribute
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch((error: any) => {
        toast.error("An error occurred while exporting persons");
      });

    setExporting(false);
  }, [apiParams]);

  return (
    <>
      <UncontrolledDropdown>
        <DropdownToggle
          tag="button"
          className="btn btn-light"
          id="dropdownMenuButton"
        >
          <i className="ri ri-more-fill"></i>
        </DropdownToggle>
        <DropdownMenu>
          <Permission resource="person" action="import">
            <DropdownItem
              onClick={() => {
                setIsImportModalOpen(true);
              }}
            >
              <i className="ri ri-upload-2-line me-1"></i>
              Import
            </DropdownItem>
          </Permission>
          <Permission resource="person" action="exportToCsv">
            <DropdownItem
              onClick={() => {
                getCsvExport();
              }}
            >
              <i className="ri ri-download-2-line me-1"></i>
              Export
            </DropdownItem>
          </Permission>
        </DropdownMenu>
      </UncontrolledDropdown>

      <PersonsImportModal
        toggle={() => setIsImportModalOpen(!isImportModalOpen)}
        isOpen={isImportModalOpen}
        onImported={onImported}
      />
      <ExportLoadingModal show={exporting} onCloseClick={() => {}} />
    </>
  );
};

export default Import;
